var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.readonly)?_c('w-text-field',_vm._b({key:_vm.key,ref:"textField",attrs:{"value":_vm.inputValue,"placeholder":_vm.internalPlaceholder},on:{"change":_vm.formatValue,"keydown":_vm.onKeyDown}},'w-text-field',_vm.$props,false)):_c('w-read-only-text-field',_vm._b({attrs:{"value":_vm.inputValue}},'w-read-only-text-field',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }